import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

export const goBackFromEditMark: ResolveFn<string> = () => {
  const router = inject(Router);
  const navigation = router.currentNavigation();
  const markId = navigation?.extras?.state?.['markId'];
  return markId ? `identify/survey-mark/${markId}` : 'smes/mark-existing';
};
